import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Pages
import Landing from "@/pages/Landing";
import AuthPage from "@/pages/AuthPage";
import OAuthCallback from "@/pages/OAuthCallback";
import AdminReviewPage from "@/pages/AdminReviewPage";

// Dashboard
import DashboardLayout from "@/dashboard/components/DashboardLayout";
import Today from "@/dashboard/pages/Today";
import LiveSession from "@/dashboard/pages/LiveSession";
import MockTest from "@/dashboard/pages/MockTest";
import MemoryGraph from "@/dashboard/pages/MemoryGraph";
import Practice from "@/dashboard/pages/Practice";
import Progress from "@/dashboard/pages/Progress";
import Goals from "@/dashboard/pages/Goals";
import Settings from "@/dashboard/pages/Settings";
import Onboarding from "@/dashboard/pages/Onboarding";

// Auth guard
import ProtectedRoute from "@/components/ProtectedRoute";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* ── Public routes ── */}
          <Route path="/" element={<Landing />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/callback" element={<OAuthCallback />} />

          {/* ── Protected routes ── */}
          <Route element={<ProtectedRoute />}>
            <Route path="/onboarding" element={<Onboarding />} />

            {/* Live session is full-screen — outside dashboard chrome */}
            <Route path="/dashboard/session" element={<LiveSession />} />
            <Route path="/dashboard/mock-test" element={<MockTest />} />

            {/* Admin Dashboard */}
            <Route path="/admin/review" element={<AdminReviewPage />} />

            <Route path="/dashboard" element={<DashboardLayout />}>
              <Route index element={<Today />} />
              <Route path="memory" element={<MemoryGraph />} />
              <Route path="practice" element={<Practice />} />
              <Route path="progress" element={<Progress />} />
              <Route path="goals" element={<Goals />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Route>

          {/* ── Fallback ── */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
